
import expirations from '@packages/cache/expirations'

export const useHotelsStore = defineStore('hotels', {
  state: () => ({
    hotels: {},
    loading: false,
    error: null,
  }),
  persist: {
    paths: ['hotels'],
    storage: persistedState.localStorageWithExpiration({
      expiration: expirations.fourMinutes,
      renewOnUpdate: false,
    }),
  },
  getters: {
    //old getters
    getHotelByGiataId: state => giataId => state.hotels[giataId],
  },
  actions: {
    //Old mutations
    SET_HOTELS (hotels) {
      this.hotels = { ...hotels }
    },
    SET_LOADING (loading) {
      this.loading = loading
    },
    SET_ERROR (error) {
      this.error = error
    },
    ADD_HOTEL (hotel) {
      this.hotels = {
        ...this.hotels,
        [hotel.giataId || hotel.giata_id]: hotel,
      }
    },
    //old actions
    async fetchSingle (giataId) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      if (!giataId) {
        return
      }

      const prevState = this.getHotelByGiataId(giataId)
      if (prevState) {
        return prevState
      }

      try {
        const { data: result } = await apiFetch(`/${locale}/hotel/${encodeURIComponent(`g${giataId}`)}`)

        const processed = processHotelInfo(result)
        this.ADD_HOTEL(processed)

        return processed
      } catch (err) {
        const { $sentryCaptureMessage } = useNuxtApp()

        $sentryCaptureMessage('hotels: Error fetching hotel', {
          level: 'warning',
          contexts: {
            details: err.data || err,
          },
          tags: {
            type: 'UX',
          },
        })
        return null
      }
    },

    async fetchAllSimple () {
      const localeStore = useLocaleStore()

      try {
        const endpoint = isSol() ? 'hotels' : 'hotelListForGroupTrips'
        const { data: result } = await apiFetch(`/${localeStore.locale}/${endpoint}`)
        const hotelArray = Object.values(result)

        return hotelArray
      } catch (e) {
        const { $sentryCaptureMessage } = useNuxtApp()

        $sentryCaptureMessage(e, 'error')
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useHotelsStore, import.meta.hot))
}